
import {
  mdiFacebook,
  mdiInstagram,
  mdiLinkedin,
  mdiWhatsapp
} from '@mdi/js'
import { mapState } from 'vuex'
import { Cms } from '@/helpers/cms'

export default {
  name: 'Cm24Footer',
  components: {},
  data () {
    return {
      mdiFacebook,
      mdiInstagram,
      mdiLinkedin,
      mdiWhatsapp,
      newsletterSignupSnackbar: false,
      newsletterSignupSnackbarText: '',
      email: undefined,
      company: [{
        link: 'about',
        name: 'about'
      },
      {
        link: 'contact',
        name: 'contact'
      },
      {
        link: 'blog',
        name: 'blog'
      },
      {
        link: 'jobs',
        name: 'jobs'
      },
      {
        link: 'partner',
        name: 'partner',
        disabled: true
      }
      ],
      social: [{
        link: 'about',
        name: 'about'
      },
      {
        link: 'contact',
        name: 'contact'
      },
      {
        link: 'blog',
        name: 'blog'
      },
      {
        link: 'jobs',
        name: 'jobs'
      },
      {
        link: 'partner',
        name: 'partner',
        disabled: true
      }
      ],
      legal: [
        {
          link: 'agb',
          name: 'agb'
        },
        {
          link: 'privacy',
          name: 'privacy'
        },
        {
          link: 'imprint',
          name: 'imprint'
        }
      ],
      merchantPageUrl: null
    }
  },
  async fetch () {
    const cms = new Cms(this.$axios)
    const response = await cms.get(`${this.$config.cmsBaseURL}/api/landing-pages`, {
      params: {
        filters: { name: { $eq: 'merchant' } },
        fields: ['url'],
        locale: this.$i18n.locale
      }
    })
    this.merchantPageUrl = `/${response.data[0].attributes.url}`
  },
  computed: {
    ...mapState('general', ['hideFooter', 'hideNavbar', 'host']),

    domain () {
      const splits = this.host?.split('.')
      return splits[splits.length - 1]
    },
    year () {
      return new Date().getFullYear()
    },

    path () {
      return this.$route.path
    },
    hideFooterOnThisPage () {
      if (this.path in this.hideFooter) {
        return this.hideFooter[this.path]
      } else {
        return false
      }
    },
    platform () {
      return [
        {
          link: '/',
          name: 'start'
        },
        {
          link: 'catalog',
          name: 'catalog'
        },
        {
          link: 'sell',
          name: 'sell'
        },
        {
          link: 'faq',
          name: 'faq'
        },
        {
          link: this.merchantPageUrl,
          name: 'merchant'
        }
      ]
    }
  },
  methods: {
    getLocalPath (item) {
      if (item.slug) {
        return this.localePath({ name: item.link, params: { slug: item.slug } })
      } else {
        return this.localePath(item.link)
      }
    },
    async submit () {
      const submission = {
        fields: [
          {
            name: 'email',
            value: this.email
          }
        ]
      }

      const instance = this.$axios.create({
        headers: {
          common: {
            Authorization: null
          }
        }
      })
      delete instance.defaults.headers.common.Authorization

      const {
        // eslint-disable-next-line no-unused-vars
        data,
        status
      } = await instance.post('https://api.hsforms.com/submissions/v3/integration/submit/9144854/9668ee64-f1c2-49a7-9536-11ce46c3e01e', submission)

      const snackbarTextKey = status === 200 ? 'subscription.success' : 'subscription.error'
      this.newsletterSignupSnackbarText = this.$t(snackbarTextKey)
      this.newsletterSignupSnackbar = true
    },
    clear () {
    }

  }
}

